export const USER_IMPACT = 'User Impact: ';
export const LINK_MESSAGE = 'SEE MORE';
export const TITLE_HEADER = 'Accessibility checker: Issue ';
export const TITLE_OF = ' of ';
export const PREV_BUTTON = 'Previous';
export const NEXT_BUTTON = 'Next';
export const NO_ISSUES_TITLE = 'Accessibility Checker';
export const NO_ISSUES_HEADER = 'Great Job';
export const NO_ISSUES_BODY = 'There is no accessibility issue.';
export const ELEMENT_STYLES = {
  text: 'accessibility_issue_text',
  block: 'accessibility_issue_block'
};
export const BLOCK = 'block';
export const TEXT = 'text';
export const TEXT_SELECTORS = ['> p', '> span', 'h1', 'h2', 'h3', 'h4'];
export const HIGHLIGHTS_CLASSES = {
  BLOCK: 'accessibility_issue_block',
  BLOCK_SELECTOR: '.accessibility_issue_block',
  TEXT: 'accessibility_issue_text',
  TEXT_SELECTOR: '.accessibility_issue_text'
};
const LABEL = {
  IMAGE: 'image',
  VIDEO: 'video',
  AUDIO: 'audio',
  DOCUMENT: 'document',
  FILE: 'file'
};
const IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'webp', 'bmp', 'gif', 'tif'];
const VIDEO_EXTENSIONS = ['mp4', 'avi', 'mov'];
const AUDIO_EXTENSIONS = ['mp3', 'wav'];
const DOCUMENT_EXTENSIONS = ['pdf', 'xls', 'xlsx', 'docx', 'doc', 'ppt', 'pptx'];
const FILE_EXTENSIONS = ['zip', 'epub', 'mobi', 'docx', 'azw3'];
export const extensionToLabelMap = new Map([...IMAGE_EXTENSIONS.map(ext => [ext, LABEL.IMAGE]), ...VIDEO_EXTENSIONS.map(ext => [ext, LABEL.VIDEO]), ...AUDIO_EXTENSIONS.map(ext => [ext, LABEL.AUDIO]), ...DOCUMENT_EXTENSIONS.map(ext => [ext, LABEL.DOCUMENT]), ...FILE_EXTENSIONS.map(ext => [ext, LABEL.FILE])]);
export const SCRIPT_TAG = 'script';
export const MATH_SCRIPT_SELECTOR = 'script[src="https://cdn.jsdelivr.net/npm/mathjax@2.7.8/MathJax.js?config=TeX-MML-AM_HTMLorMML"]';
export const MATH_SCRIPT_URL = 'https://cdn.jsdelivr.net/npm/mathjax@2.7.8/MathJax.js?config=TeX-MML-AM_HTMLorMML';
export const MATH_SCRIPT_TYPE = 'text/javascript';
export const WARNING_LOADING_ADDON = {
  type: 'warning',
  message: 'There was a problem loading an addon, please refresh'
};